module.exports = require("@material-ui/core/Collapse");